// projects.js
// Merges the generated dataset (updated daily by scripts/update-projects.mjs)
// with hand-written es/ru translations. Keys: gh URL, or owner/name for
// private repos, or site URL for non-repo products.
import DATA from './projects.generated.json';
import TRANSLATIONS from './projects.translations.json';

const keyFor = (project) => {
    if (project.gh) {
        return project.gh;
    }

    if (project.owner) {
        return `${project.owner}/${project.name}`;
    }

    return project.site;
};

const translationFor = (project) => (
    TRANSLATIONS[keyFor(project)]
    || (project.owner ? TRANSLATIONS[`${project.owner}/${project.name}`] : null)
    || (project.gh ? TRANSLATIONS[project.gh] : null)
    || {}
);

const PROJECTS = DATA.map((project) => ({
    ...project,
    ...translationFor(project),
}));

export default PROJECTS;
